import 'react-app-polyfill/ie11';
import 'core-js';
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Localization from "./utils/localization";
import store from "./redux/store";
import theme from "./themes/theme";
import { ThemeProvider } from "@material-ui/core";
import { Provider as ReduxProvider } from "react-redux";

ReactDOM.render(
  <ReduxProvider store={store}>
    <Localization store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Localization>
  </ReduxProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
